import type { DasOverrides, DasPayload } from '@makemydeal/dr-dash-types';

export const getDasRequestPayload = (dasOverrides: DasOverrides): DasPayload => {
    return {
        downPayment: dasOverrides.downPayment,
        isTargetOutOfPocket: dasOverrides.targetCashAmountPaid as boolean,
        capitalizeFirstPayment: dasOverrides.firstPaymentCapitalized as boolean,
        equityAllocationMethod: dasOverrides.equityAllocationMethod as string,
        ...(dasOverrides.feesCapitalized != null && { feesOverride: dasOverrides.feesOverride }),
        ...(dasOverrides.taxesCapitalized != null && { taxItems: dasOverrides.taxItems }),
        ...(dasOverrides.taxesCapitalized != null && { taxOverrideUpfront: dasOverrides.taxesCapitalized as boolean })
    };
};

export const isDASRequestAborted = (message: string): boolean => {
    const keywords = ['signal', 'abort'];
    const lowerMessage = (message || '').toLowerCase();
    return keywords.some((keyword) => lowerMessage.includes(keyword));
};
